/**
 * Reading a fetch Response safely — shared by the project-channel reads and
 * writes so both report the API's own message when there is one.
 */

/** Read `{ error }` from a body that may be anything, incl. an HTML error page. */
export function readErrorMessage(body: unknown, fallback: string): string {
  if (typeof body === "object" && body !== null) {
    const { error } = body as { error?: unknown };
    if (typeof error === "string" && error.trim().length > 0) return error;
  }
  return fallback;
}

export async function readJson(response: Response): Promise<unknown> {
  try {
    return (await response.json()) as unknown;
  } catch {
    // A proxy or gateway can answer with HTML. There is nothing better to show
    // than the caller's fallback, so degrade to that rather than throwing.
    return null;
  }
}
